<script setup lang="ts">
/** [[if retiring_directors]][[director_name]][[/if retiring_directors]] — 퇴임(재선임) 이사 목록 편집. */
import AgmRowsEditor from './AgmRowsEditor.vue';
import { useAgmStudio } from './agmStudioContext';

const { model, lookup } = useAgmStudio();
</script>

<template>
  <AgmRowsEditor :rows="model.retiringDirectors" add-label="+ Add retiring director" placeholder="Director name"
    empty-note="Add the retiring director(s) to be re-elected."
    @lookup="(i: number) => lookup({ fieldGroup: 'retiringDirector', index: i, defaultRole: 'DIRECTOR' })" />
</template>
